export default class LateRequest {
    constructor($q, $injector, $rootScope, TokenHandler) {
        this.requests = [];
        this.dontRetry = ['/user/login/refresh'];
        this._q = $q;
        this._rootScope = $rootScope;
        this._injector = $injector;
        this.$http = null;
        this.tokenHandler = TokenHandler;
    }

    add(response) {
        let deferred = this._q.defer();

        this.requests.push({
            config: response.config,
            deferred: deferred
        });
        return deferred.promise;
    }

    getAll() {
        return this.requests;
    }

    updateHeadersWithToken(request) {
        request.config.headers['Authorization'] = 'Bearer ' + this.tokenHandler.getToken();

        return request;
    }

    retryAll() {
        this.$http = this.$http || this._injector.get('$http');
        angular.forEach(this.requests, (request) => {
            request = this.updateHeadersWithToken(request);
            if (this.dontRetry.indexOf(request.config.url) == -1) {
                this.$http(request.config).then((response) => {
                    request.deferred.resolve(response);
                });
            }
        });

        this.requests = [];
    }
}

LateRequest.$inject = ['$q', '$injector', '$rootScope', 'TokenHandler'];